export default "__VITE_ASSET__D8XMlD_C__"